import { defineComponent as _defineComponent } from 'vue'
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import CcModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcModal.ts.vue';
import { CardLayer } from '@/views/Automation/CampaignCreatorV2/types';
import { computed, ref, watch } from 'vue';

interface Props {
  isModalOpen: boolean;
  title: string;
  modalTitle?: string;
}

interface Emits {
  (event: 'onCancel'): void;
  (event: 'onSave', value: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcRenameModal.ts',
  props: {
    isModalOpen: { type: Boolean },
    title: null,
    modalTitle: null
  },
  emits: ["onCancel", "onSave"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'onCancel'): void;
  (event: 'onSave', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isModalOpen: boolean;
  title: string;
  modalTitle?: string;
};


const newTitle = ref<string>(props.title);

watch(
  () => props.title,
  (newValue) => {
    newTitle.value = newValue;
  }
);

const disabledMessage = computed(() => {
  if (!newTitle.value) return 'This field can not be empty';
  if (newTitle.value === props.title) return 'The new name is the same as the old one';
  return '';
});



function onSaveClick() {
  emits('onSave', newTitle.value);
}

function onModalClose() {
  newTitle.value = props.title;
  emits('onCancel');
}

return { __sfc: true,props, newTitle, disabledMessage, emits, onSaveClick, onModalClose, CcCardItem, CcError, CcModal, CardLayer }
}

})